import type { ProcessStepsBlock } from "../../../services/educationService";
import styles from "./article.module.css";

export function ArticleSteps({ block }: { block: ProcessStepsBlock }) {
	return (
		<div className={styles.steps}>
			{block.intro && <p className={styles.stepsIntro}>{block.intro}</p>}
			<ol className={styles.stepsList}>
				{block.steps.map((s) => (
					<li key={s.number} className={styles.step}>
						<span className={styles.stepBadge}>{s.number}</span>
						<div>
							<h4 className={styles.stepTitle}>{s.title}</h4>
							<p className={styles.stepBody}>{s.body}</p>
						</div>
					</li>
				))}
			</ol>
		</div>
	);
}
